<template>
  <div class="home " id="home">
    <div class="banner">
      <van-swipe class="my-swipe" :autoplay="autotime" indicator-color="white" >
        <van-swipe-item v-for="(item,index) in bannerList" :key="index" @click="swiperClick(item)">
          <img  :src="item.phoLink"  alt="" >
        </van-swipe-item>
      </van-swipe>
      <!--        <swiper class="swiper" :options="swiperOption">-->
      <!--          <swiper-slide v-for="(item,index) in bannerList" v-bind:key="index" @click="swiperClick" :data-index="index">-->
      <!--            <img :src="item" alt="" v-if="videoFlag">-->
      <!--            <video-->
      <!--                v-if="!videoFlag"-->
      <!--                style="width: 100%;height: 100%;"-->
      <!--                ref="video"-->
      <!--                class="video-js vjs-default-skin"-->
      <!--                controls-->
      <!--                playsinline = true-->
      <!--                webkitPlaysinline = true-->

      <!--            >-->
      <!--              <source src="https://testsohochina.oss-cn-beijing.aliyuncs.com/dev/2020/07/t7kjvluha9pw.mp4" />-->
      <!--            </video>-->
      <!--          </swiper-slide>-->
      <!--        </swiper>-->
    </div>
   <div class="blank clearfix" id="blank-content">
     <div class="love-sort" @click="loveCLick">
       <div class="love-sort-text">
         爱心图书榜
       </div>
       <i class="iconfont icon-youjiantou"></i>
       <div class="love-sort-scroll">
         <seamscroll :listData="listData"></seamscroll>
       </div>
     </div>

     <div class="home-content">
       <div class="home-content-title">
         <span>募投项目</span>
       </div>
       <ul>
         <li class="home-content-item" v-for="(item,index) in projectList"  @click="changeRouter(item)" :key="index">
           <img :src="JSON.parse(item.phoLink).idxLink" alt="">
           <div class="home-item-text">
             <span>{{item.activTitle}}</span>
             <span class="item-text-willing" v-if="item.activStatus == 0">敬请期待</span>
             <span class="item-text-active" v-if="item.activStatus == 1">募集中</span>
             <span class="item-text-end" v-if="item.activStatus == 2">募集已结束</span>
           </div>
         </li>
       </ul>
     </div>
     <div class="line">
       <span class="line-span"></span>
       <span class="line-point"></span>
       <span class="line-span"></span>
     </div>
     <div class="footer">
       <p>
         家育苑养正幼儿园是一所非盈利幼儿园，SOHO中国基金会每年补贴运营管理费。这所位于大山里的幼儿园从建设到开学，凝聚了社会各界的爱心，是一所充满美德和爱的幼儿园。目前已经有180名孩子就读。对于留守儿童和经济有困难的家庭，幼儿园会优先录取。
       </p>
       <div class="logo">
         <img src="../assets/frame.png" alt="" >
       </div>
     </div>

   </div>
    <van-popup v-model="videoShow" @close="popuoCLose">
      <div class="video-wrapper">
        <video
            ref="video"
            class="video-js vjs-default-skin"
            controls
            :poster="lgLink"
            :src="mvUrl"
        >
        </video>
      </div>
    </van-popup>
    <div class="top" @click="backTop">
      <img src="/top.png" alt="">
    </div>

  </div>
</template>

<script>
import seamscroll from "../component/seamscroll";
import {getLoveOrgan, proOrders, proLst,loveBanner, getLovePerson} from "../api";
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import {Toast} from "vant";
import 'swiper/css/swiper.css'
export default {
  name: "home",
  components:{
    seamscroll,
    // Swiper,
    // SwiperSlide
  },
  created() {
    this.loveBoard()
    this.proLst()
    this.getBanner()

  },
  mounted() {
    this.$nextTick(()=>{
      let blankHeight = document.getElementById('blank-content').offsetHeight
      console.log( document.getElementById('blank-content').offsetHeight)
    })

  },
  data() {
    // 这里存放数据
    return {
      videoShow:false,
      autotime:5000,
      listData:[],
      projectList:[],
      bannerList:[],
      lgLink:'',
      lgVideo:'',
      mvUrl:''
    }
  },
  methods:{
    videoClick(item,index){
      if(item.phoUrl){
        this.autotime = null
        console.log(this.$refs[`video${index}`])
        this.$refs[`video${index}`][0].play()
      }
    },
    getLink(item){
      var suffix = item.split('.').pop();
      if(suffix == 'mp4'){
        return false
      }else {
        return true
      }
    },
    async getBanner(){
      const res = await loveBanner();
      if (res.code === 200){
        let bannerData = res.data
        // this.bannerList = bannerData.map(v =>v.phoLink)
        this.bannerList = bannerData
      }
      Toast.loading({
        duration: 100,
        message: '加载中...',
        forbidClick: true,
      });
    },
    async loveBoard(){
      Toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      // const res = await getLoveOrgan({'proId': 3});
      const res = await getLovePerson({'proId': 3});
      if (res.code === 200){
        this.listData= res.data
      }
    },
    async proLst(){
      const res = await proLst()
      if (res.code === 200){
        this.projectList= res.data.list
      }
    },
    onChange(index){
     // let video = this.$refs[`video${index}`][0]
     //  video.paused
       //       if(video.paused){  //如果已暂停则播放
       //     video.play(); //播放控制
       // }else{ // 已播放点击则暂停
       //     video.pause(); //暂停控制
       // }
      // console.log(video)
      // video.currentTime = 0;
      // this.autotime = 8000
   },


    backTop() {
      document.documentElement.scrollTop = 0;
    },
    loveCLick(){
      // this.$router.push("/loveraise")
      this.$router.push({path:'/library',query:{proId:3,libid:3}})
    },
    swiperClick(item,index){
      if(item.phoUrl){
        this.$nextTick(() => {
          this.mvUrl =item.phoUrl
          this.lgLink = item.phoLink
          this.videoShow = true
          setTimeout(()=>{
            this.$refs.video.play()
          },1000)
        })

      }

      // this.autotime = null
      // this.videoFlag = false
      // this.$refs[`video${index}`][0].play()
    },
    popuoCLose(){
      let video =this.$refs.video
      video.currentTime = 0;
      video.pause()
    },
    changeRouter(item){
      let pathUrl = item.proId == 3 ? '/library':'/project'
      if(item.activStatus ==1 || item.activStatus ==2){
        this.$router.push({
          path: pathUrl,
          query: {
            proId: item.proId
          }
        })
      }
    },
  },
  // watch: {
  //   mvUrl(newValue, oldValue) {
  //     let video = this.$refs.video
  //     console.log(video.src)
  //     video.src = this.mvUrl;
  //   }
  // }

}
</script>
<style>
.van-swipe__indicators{
  bottom: 80px !important;
}
.van-overlay{
  background-color: rgba(0,0,0,.8) !important;
}
.clearfix::after{
  content: '';
  display: table;
  clear: both;
}
</style>
<style scoped lang="scss">

.home{
  position: relative;
  height: 3100px;
  background-color:#F1EFF1;
  &::after{
    content: '';
    display: table;
    clear: both;
  }
  .banner{
    width: 750px;
    //height: 427px;
    img{
      display: block;
      width: 100%;
      //height: 427px;
    }
    .video-js{
      display: block;
      width: 100%;
      height: 100%;
      background-color:#F1EFF1;
    }
  }
  .love-sort{
    width: 90%;
    height: 240px;
    margin: 0 auto;
    margin-top: 0px;
    background: url("~@/assets/lovebackgrond.png");
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: space-around;
    border-radius: 20px;
    .love-sort-text{
      width: 260px;
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 600;
      font-size: 42px;
      color: #A471AA;
      box-sizing: border-box;
      padding-left: 20px;
    }
    .iconfont{
      font-size: 38px;
      color: #A471AA;
    }
  }
  .home-content{
    border-radius: 30px;
    //background-color: #FFFFFF;
    width: 90%;
    margin: 0 auto;
    .home-content-title{
      width:100%;
      box-sizing: border-box;
      span{
        display: block;
        padding: 40px 0px 0;
        font-size: 28px;
        color: #BBB0BC;
        font-family: 'PingFang SC'
      }
    }
    .home-content-item{
      overflow: hidden;
      margin-top: 30px;
      border-radius: 20px;
      background-color: #FFFFFF;

      img{
        width: 100%;
        display: block;
        width: 740px;
        height: 320px;
        background-color: whitesmoke;
        border-top-right-radius: 20px;
        border-top-left-radius: 20px;
      }
      .home-item-text{
        padding: 40px 30px;
        display: flex;
        justify-content: space-between;
        span{
          font-family: PingFang SC;
          color: #312E31;
          font-size: 38px;
        }
        span:nth-child(1){
          font-weight: 600;
        }
        .item-text-active{
          border: 1px solid #A471AA;
          font-size: 28px;
          padding: 10px;
          border-radius: 10px;
          color: #A471AA;
        }
        .item-text-end{
          border: 1px solid #BDB4BE;
          font-size: 28px;
          padding: 10px;
          border-radius: 10px;
          color: #BDB4BE;
        }
        .item-text-willing{
          border: 1px solid#C3A437;
          font-size: 28px;
          padding: 10px;
          border-radius: 10px;
          color: #C3A437;
        }
      }
    }
  }
  .line {
    width: 35%;
    text-align: center;
    display: flex;
    align-items: center;
    margin: 74px auto 50px;
  }
  .blank{
    box-sizing: border-box;
    padding-top: 30px;
    width: 100%;
    height: 600px;
    background:url("../assets/blank3.png")  no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0;
    top: 550px;
  }
  .line span {
    display: block;
  }
  .line-span{
    width: 120px;
    display: block;
    height: 1px;
    background:#D3C4D5;

  }
  .line-point{
    width: 4px;
    height: 4px;

    background: #D7CFD7;
    transform: rotate(-45deg);
    margin: 0 20px;
  }
  .footer{
    width: 90%;
    margin: 0 auto;
    .logo{
      margin: 0 auto;
      img{
        width: 132px;
        height: 146px;
        display: block;
        margin: 20px auto 0;
      }
    }

    p{
      font-family:PingFang HK;
      font-size: 28px;
      line-height: 164%;
      color: #A49BA3;
    }

  }
  .top{
    position: absolute;
    bottom: 190px;
    right: 40px;
    z-index: 1;
  }
  .top img{
    width: 76px;
    height:76px;
  }
  .video-wrapper {
    width: 680px;
    position: relative;
    height: 500px;
    margin:0 auto;
    video{
      position: absolute;
      top:0;
      left: 0;
      width: 100%;
      height: 100%
    }
  }

}
</style>
